<template>
  <div class="topbar">
    <div class="fbox">
      {{ title }} <span class="numbermore">{{ num > 100 ? '100+' : num }}</span>
      <div class="time" v-if="!isShowMore" @click="changeTime">
        <span>竞价时间</span>
        <i v-show="bidSortType === ''" class="el-icon-bottom"></i>
        <i v-show="bidSortType === 'desc'" class="el-icon-top"></i>
      </div>
    </div>
    <span class="more2" v-if="isShowMore" @click="toMore">
      更多
      <i class="el-icon-arrow-right"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'topbar',
  props: {
    num: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bidSortType: 'desc'
    }
  },
  computed: {
    isShowMore() {
      const { path } = this.$route
      return path.indexOf('biddingSpecial/index') >= 0
    }
  },
  methods: {
    changeTime() {
      this.bidSortType = this.bidSortType === '' ? 'desc' : ''
      this.$nextTick(() => {
        this.$emit('changeTimeFun', this.bidSortType)
      })
    },
    toMore() {
      const obj = {
        正在竞价: '/biddingSpecial/start',
        竞价结束: '/biddingSpecial/end',
        竞价预告: '/biddingSpecial/notice'
      }
      const { query } = this.$route
      this.$router.push({
        path: obj[this.$props.title],
        query
      })
    }
  }
}
</script>

<style lang="less" scoped>
.topbar {
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Source Han Sans CN';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  padding: 0 20px 0 20px;
  border-bottom: 2px solid #2587ff;
  height: 60px;
  .numbermore {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    color: #2587ff;
    display: inline-block;
    margin-left: 20px;
  }
  .more2 {
    cursor: pointer;
    font-size: 16px;
    color: #0064c8;
    display: flex;
    align-items: center;
  }
  .fbox {
    display: flex;
  }
  .time {
    color: #2587ff;
    margin-left: 20px;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    i {
      font-weight: bold;
      font-size: 15px;
      margin-left: 2px;
    }
  }
}
</style>
